import { render, staticRenderFns } from "./PointRedemption.vue?vue&type=template&id=0945fac4&scoped=true&"
import script from "./PointRedemption.vue?vue&type=script&lang=js&"
export * from "./PointRedemption.vue?vue&type=script&lang=js&"
import style0 from "./PointRedemption.vue?vue&type=style&index=0&id=0945fac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0945fac4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
